// src/components/CustomNavbar.jsx
import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Offcanvas,
  Modal,
  Form,
  Alert,
  Spinner,
} from "react-bootstrap";
import { db } from "../firebase"; // adjust path if needed
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./CustomNavbar.css";
import logo from "../assets/logo.png";

const CustomNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (show) document.body.classList.add("offcanvas-open");
    else document.body.classList.remove("offcanvas-open");
  }, [show]);

  const openQuote = () => {
    // close offcanvas if open (avoid scroll lock conflicts)
    setShow(false);
    setShowModal(true);
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      // write to Firestore quotes collection
      await addDoc(collection(db, "quotes"), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        createdAt: serverTimestamp(),
      });

      setSuccess("✅ Your request has been submitted!");
      setFormData({ name: "", email: "", phone: "", message: "" });

      // auto-close success after 2.5s
      setTimeout(() => {
        setSuccess("");
        setShowModal(false);
      }, 2500);
    } catch (err) {
      // show the exact error so you can diagnose
      console.error("Firestore write error:", err);
      setError(err?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar
        expand="lg"
        fixed="top"
        className={`custom-navbar ${scrolled ? "scrolled" : ""}`}
      >
        <Container>
          <Navbar.Brand href="#">
            <img src={logo} alt="logo" className="logo" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={() => setShow(true)} />

          <div className="d-none d-lg-flex align-items-center ms-auto">
            <Nav className="me-4">
              <Nav.Link href="/" className="active">Home</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <Nav.Link href="/service">Services</Nav.Link>
               {/*<Nav.Link href="/Blog">Blog</Nav.Link>*/}
              <Nav.Link href="/contact">Contact</Nav.Link>
            </Nav>

           {/*
<Button variant="danger" className="fancy-btn me-3" onClick={openQuote}>
  GET A QUOTE →
</Button>
*/}

            <div className="call-box d-none d-lg-flex">
              <div className="icon"><i className="bi bi-telephone-fill"></i></div>
              <div>
                <small>Call Us Now</small>
                <p className="mb-0 fw-bold"> +971 50 576 5759</p>
              </div>
            </div>
          </div>
        </Container>
      </Navbar>

      <Offcanvas show={show} onHide={() => setShow(false)} placement="end" id="offcanvasNavbar" scroll={false} backdrop={true}>
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link href="/service">Services</Nav.Link>
           {/* <Nav.Link href="/Blog">Blog</Nav.Link>*/}
            <Nav.Link href="/contact">Contact</Nav.Link>
          </Nav>

          {/*<Button variant="danger" className="quote-btn mt-3 w-100" onClick={openQuote}>
            GET A QUOTE <span className="arrow">→</span>
          </Button>*/}

          <div className="call-box mt-4 d-flex">
            <div className="icon"><i className="bi bi-telephone-fill"></i></div>
            <div>
              <small>Call Us Now</small>
              <p className="mb-0 fw-bold"> +971 50 576 5759</p>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Get a Quote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {success && <Alert variant="success">{success}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control name="name" value={formData.name} onChange={handleChange} type="text" placeholder="Enter your name" required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control name="email" value={formData.email} onChange={handleChange} type="email" placeholder="Enter your email" required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control name="phone" value={formData.phone} onChange={handleChange} type="tel" placeholder="Enter your phone number" required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control name="message" value={formData.message} onChange={handleChange} as="textarea" rows={3} placeholder="Your message" />
            </Form.Group>

            <Button variant="danger" type="submit" className="w-100" disabled={loading}>
              {loading ? (<><Spinner animation="border" size="sm" /> Sending...</>) : "Submit Request"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CustomNavbar;
